import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { SortDirection, buildPagedSortQueryParams } from '../utils/pagedSortQueryParams';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'serviceJob/';

export type ServiceJobSortField = 'completedOn' | 'jobNumber' | 'jobStatus' | 'lastUpdated' | 'total';

export function useServiceJobFilter({
	filterRequest,
	pageSize = 25,
	sortBy = 'completedOn',
	sort = 'desc',
	enabled = true,
	refetchOnWindowFocus = false,
	expand = 'contact',
}: {
	filterRequest: Api.IServiceJobFilterRequest;
	pageSize?: number;
	sortBy?: ServiceJobSortField;
	sort?: SortDirection;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	expand?: string;
}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.IServiceJob>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IServiceJob>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: buildPagedSortQueryParams({ pageSize, pageToken: pageParam, sortBy, sort, expand }),
					urlPath: 'ServiceJob/filter',
				}),
				'POST',
				filterRequest
			);
		},
		refetchOnWindowFocus,
		queryKey: [BASE_QUERY_KEY, filterRequest, pageSize, sortBy, sort, expand],
		initialPageParam: '',
	});
}

export const invalidateAllServiceJobFilters = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
